<!-- SCREENING NOTE$S component -->
<template>
  <md-card id="vision" class="md-with-hover">
    <md-card-header class="md-card-header-icon md-card-header-primary">
      <div class="md-layout">
        <div class="card-icon" style="margin-left: 5px; margin-top: -7px; margin-right: 0px">
          <md-icon>note_alt</md-icon>
        </div>

        <div class="md-layout-item">
          <h4 class="title" style="font-weight: 400">Internal Screening Notes</h4>
        </div>

        <div class="md-layout md-layout-item md-alignment-center-right">
          <md-button
            slot="title"
            class="md-button md-success md-sm"
            style="margin-top: 15px; margin-right: 10%"
            @click="saveNotes()"
          >
            SAVE Notes
          </md-button>
        </div>
      </div>
    </md-card-header>

    <md-card-content>
      <div class="md-layout md-alignment-center">
        <div class="md-layout md-gutter md-alignment-space-around-center">
          <div class="md-layout-item md-size-90">
            <md-field id="comments">
              <!--<label style="margin-left:5px;">Notes</label>-->
              <md-textarea
                autocomplete="off"
                aria-autocomplete="none"
                id="ouNotes"
                v-model="getNotes"
                style="background-color: #efefef; line-height: 1.5em"
              />
            </md-field>
          </div>
        </div>
      </div>
      <hr style="margin-top: 30px" />
    </md-card-content>
    <!--<hr style="width: 95%; border-bottom: 2px" >  -->
  </md-card>
</template>

<script>
import { mapGetters } from "vuex"
import Swal from "sweetalert2"
import { bus } from "@/main"
//import { get } from "jquery";
//import { set } from "vue/types/umd";
export default {
  name: "screeningNOTES",

  data() {
    return {
      API_SERVICE: process.env.VUE_APP_URL
    }
  },
  computed: {
    ...mapGetters(["notesInfo"]),
    getReader: function () {
      return sessionStorage.getItem("userID")
    },
    getNotes: {
      get: function () {
        return this.notesInfo.screeningNote
      },
      set: function (newValue) {
        //
      }
    }
  },
  mounted() {
    bus.$on("executeSave", () => {
      this.saveNotes(true)
    })
  },
  methods: {
    changedNotes() {
      //
    },
    saveNotes(noSwal = false) {
      const vm = this
      const packageID = sessionStorage.getItem("screeningID")
      const config = { headers: { "Content-Type": "application/json" } }
      const url = vm.API_SERVICE + "/screening/"
      const data = {
        pkgid: packageID,
        field: "screeningNotes",
        data: document.querySelector("#ouNotes").value
      }
      console.log("screening:PATCH " + url)
      window.axios
        .patch(url, data, config)
        .then((response) => {
          console.log("Screening PATCH Response: " + response)
          if (noSwal) {
            return
          }
          Swal.fire({
            //title: "Save Screening Notes",
            text: "Note Saved",
            timer: 1200,
            showConfirmButton: false
          })
        })
        .catch((error) => {
          console.log("Screening PATCH ERROR: " + error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
#vision {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.mlabel {
  font-size: 0.8em;
}
</style>
